export const locations = [
    { url: '63669ed9a22c6637c22d7462', lat: '33.9846', lang: '71.4281', sponseredbybok: true, placeName: 'Industrial Estate (Hayatabad)' },
    { url: '6362a6ea739f843f120d22cd', lat: '34.0301', lang: '71.6031', sponseredbybok: true, placeName: 'Dalazak Road' },
    { url: '63600cb8b959dfaee2b0e41e', lat: '34.0007', lang: '71.5379', sponseredbybok: true, placeName: 'Mall Road' },
    { url: '63623f2f739f843f12d5890d', lat: '34.0084', lang: '71.5112', sponseredbybok: true, placeName: 'Tehkal' },
    { url: '63600f8d5ffc4069fb78a143', lat: '34.0094', lang: '71.6126', sponseredbybok: true, placeName: 'G.T. Road' },
    { url: '636bd09427d47654435bb786', lat: '34.0232', lang: '71.6604', sponseredbybok: true, placeName: 'Garhi Qamar Din' },
    { url: '6363968b0455bea4f0383c38', lat: '33.9966', lang: '71.462', sponseredbybok: true, placeName: 'Phase 3 Chowk' },
    { url: '63635f6456d2f0638bf6fe2d', lat: '34.0286', lang: '71.6006', sponseredbybok: true, placeName: 'Charsadda Road' },
    { url: '6364f078e851eb899ca98ac1', lat: '34.0179', lang: '71.6911', sponseredbybok: true, placeName: 'Chamkani' },
    { url: '62c55ef09239c5257e9a3dfc', lat: '34.0109', lang: '71.5579', sponseredbybok: false, placeName: 'Civil Secreatariat' },
    { url: '62baacf2d61e92dc55b482cb', lat: '34.0482', lang: '71.5199', sponseredbybok: false, placeName: 'Yousafabad, Warsak Road' },
    { url: '5fdb0bc345047a4d3d83d677', lat: '33.961622', lang: '71.445537', sponseredbybok: false, placeName: 'Hayatabad (Phase 2)' }
]

export const getcolorclass = (type, value) => {
    let class_name = '', class_text = '', faceIcon = '', recomendationurl = '';
    if (value >= 0 && value <= 50) {
        class_name = 'good'
        class_text = 'Good'
        faceIcon = <i className="bi bi-emoji-smile"></i>;
        recomendationurl = 'https://pcaakp.org/wp-json/wp/v2/aqirecomendationn/1792'
    }
    if (value > 50 && value <= 100) {
        class_name = 'moderate'
        class_text = 'Moderate'
        faceIcon = <i className="bi bi-emoji-neutral"></i>;
        recomendationurl = 'https://pcaakp.org/wp-json/wp/v2/aqirecomendationn/1801'
    }
    if (value > 100 && value <= 150) {
        class_name = 'unhealthy-for'
        class_text = 'Unhealthy for sensitive group'
        faceIcon = <i className="bi bi-emoji-expressionless"></i>;
        recomendationurl = 'https://pcaakp.org/wp-json/wp/v2/aqirecomendationn/1804'
    }
    if (value > 150 && value <= 200) {
        class_name = 'unhealthy';
        class_text = 'Unhealthy';
        faceIcon = <i className="bi bi-emoji-frown"></i>;
        recomendationurl = 'https://pcaakp.org/wp-json/wp/v2/aqirecomendationn/1808'
    }
    if (value > 200 && value <= 300) {
        class_name = 'v-unhealthy';
        class_text = 'very Unhealthy';
        faceIcon = <i className="bi bi-emoji-angry"></i>;
        recomendationurl = 'https://pcaakp.org/wp-json/wp/v2/aqirecomendationn/1811'

    }
    if (value > 300) {
        class_name = 'hazardous';
        class_text = 'Hazardous';
        faceIcon = <i className="bi bi-emoji-dizzy"></i>;
        recomendationurl = 'https://pcaakp.org/wp-json/wp/v2/aqirecomendationn/1813'
    }
    if (type == 'recomendationurl') {
        return recomendationurl
    }
    if (type == 'color') {
        return class_name
    }
    if (type == 'text') {
        return class_text
    }
    if (type == 'icon') {
        return faceIcon
    }

}

export const tooltipContent = {
    whatIsAQI: "The U.S. Air Quality Index, or AQI, is a tool for reporting and communicating daily air quality. It uses color-coded categories and provides statements for each category that tell you about air quality in your area, which groups of people may be affected, and steps you can take to reduce your exposure to air pollution. The higher the AQI value, the greater the level of air pollution and the greater the health concern.",
    pm25: "PM2.5 : fine inhalable particles, with diameters that are generally 2.5 micrometers and smaller.",
    pm10: "PM10 : inhalable particles, with diameters that are generally 10 micrometers and smaller."
}

export const GradeType = {
    GOOD: 'GOOD',
    MODERATE: 'MODERATE',
    UNHEALTHY_SENSITIVE: 'UNHEALTHY_SENSITIVE',
    UNHEALTHY: 'UNHEALTHY',
    VERY_UNHEALTHY: 'VERY_UNHEALTHY',
    HAZARDOUS: 'HAZARDOUS',
}

